import { render } from "./Onboarding2.vue?vue&type=template&id=01fe17e8&scoped=true"
import script from "./Onboarding2.vue?vue&type=script&lang=js"
export * from "./Onboarding2.vue?vue&type=script&lang=js"

import "./Onboarding2.vue?vue&type=style&index=0&id=01fe17e8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-01fe17e8"

export default script